import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { AuthUser, UserRole } from '../../ts/interfaces/interfaces'

type IUserState = Partial<Omit<AuthUser, 'id' | 'token' | 'role' | 'tax_information'>> & {
  id: number | null
  token: string | null
  role: UserRole
  downloadExpensesFields?: string[] | null
  email: string
  phone_numbers: string[]
}

const initialUserJson: IUserState = {
  id: null,
  email: '',
  token: null,
  phone_numbers: [],
  role: UserRole.EMPLOYEE,
  name: '',
  businesses: [],
  downloadExpensesFields: []
}

const getInitialState = (): IUserState => {
  try {
    const userStr = localStorage.getItem('user')
    if (!userStr) return initialUserJson
    return JSON.parse(userStr) as IUserState
  } catch (error) {
    console.error('Error parsing user from localStorage:', error)
    localStorage.removeItem('user')
    return initialUserJson
  }
}

const initialState: IUserState = getInitialState()

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetails: (state, action: PayloadAction<IUserState>) => {
      localStorage.setItem('user', JSON.stringify(action.payload))
      return { ...state, ...action.payload }
    },
    signIn: (state, action: PayloadAction<IUserState>) => {
      localStorage.removeItem('user')
      localStorage.setItem('user', JSON.stringify(action.payload))
      return { ...state, ...action.payload }
    },
    logOut: () => {
      localStorage.removeItem('user')
      return initialUserJson
    },
    refreshToken: (state, action: PayloadAction<{ token: AuthUser['token'] }>) => {
      try {
        const userStr = localStorage.getItem('user')
        if (!userStr) return state

        const user = JSON.parse(userStr) as AuthUser
        user.token = action.payload.token

        localStorage.setItem('user', JSON.stringify(user))
        return { ...state, token: action.payload.token }
      } catch (error) {
        console.error('Error refreshing token:', error)
        return state
      }
    }
  }
})

export const { setUserDetails, logOut, signIn, refreshToken } = userSlice.actions

export default userSlice.reducer
